module.exports = __webpack_public_path__ + "img/heart.388a17f4.svg";